import { TREASURY_AND_ACCOUNTING_URL } from "utils/constants";
import { ENDPOINTSTREASURYANDACCOUNTING } from "utils/endpoints";
import { http } from "utils/http";

export const getDocsClassification = async (Id) =>
  await http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseDefinitionAndSettingApi
      .DocsClassification.load,
    method: "get",
    params: { Id: Id },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const postDocsClassificationApi = (data) =>
  http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseDefinitionAndSettingApi
      .DocsClassification.browse,
    method: "post",
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const putDocsClassificationApi = (data) =>
  http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseDefinitionAndSettingApi
      .DocsClassification.browse,
    method: "put",
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const getDocsClassificationDictionary = async () =>
  await http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseDefinitionAndSettingApi
      .DocsClassification.dictionary,
    method: "get",
  }).then((response) => response.data);

export const deleteListDocsClassification = (id) =>
  http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseDefinitionAndSettingApi
      .DocsClassification.browse,
    method: "delete",
    params: {
      id: id,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const getListDocsClassification = async (
  searchString,
  orderBy,
  pageNum,
  pageSize,
  applicationId
) =>
  await http({
    baseURL: TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Treasury.BaseDefinitionAndSettingApi
      .DocsClassification.browse,
    method: "get",
    params: {
      searchString: searchString,
      orderBy: orderBy,
      PageSize: pageSize,
      PageNumber: pageNum,
      ApplicationId: applicationId,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
